import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

export const mayMentalHealthToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.MAY_MENTAL_HEALTH,
  iFrameSrcUrl: '/may',
  micrositeUrl: 'may',
  title: {
    id: 'mayMentalHealthToolkit.title',
    defaultMessage: 'Mental Health Awareness Month',
    description: 'Microsite page title',
  },
  featureFlag: 'isMayMentalHealthToolkitEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events/curious-about-mental-health-support',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_REGISTRATION,
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT },
  ],
  page: '202605 mham',
  trackUTMParams: {
    utm_campaign: 'May526',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'mham',
  },
  shouldSupportSpanish: false,
  shouldHideForInternational: true,
}
